import { useEffect, useState } from 'react';
import { Platform } from 'react-native';
const CHANNEL_NAME = 'vuelto-single-instance';
const PING_MSG = 'ping';
const PONG_MSG = 'pong';
const PONG_TIMEOUT_MS = 400;

export type InstanceGuardState = 'checking' | 'allowed' | 'blocked';

/**
 * Detecta si otra pestaña de Vuelto (mismo origin) está abierta.
 * En web sin OPFS: siempre allowed (no hay pelea por Access Handle).
 * En native: siempre permite (no aplica).
 */
export function useSingleInstanceGuard(): InstanceGuardState {
  const [state, setState] = useState<InstanceGuardState>(() => {
    if (Platform.OS !== 'web') return 'allowed';
    return 'allowed';
  });

  useEffect(() => {
    if (Platform.OS !== 'web' || typeof window === 'undefined') return;
    setState('allowed');
            return;
  }, []);

  return state;
}
